<script setup>
import { ref, watch } from 'vue';
import BaseSelect from '@/components/forms/BaseSelect.vue';

const props = defineProps({
  modelValue: String,
  options: {
    type: Array,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  minWidthLabel: {
    type: String,
    default: '8ch'
  }
});

const emits = defineEmits(['update:modelValue']);

const localValue = ref(props.modelValue);

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue);
});

watch(() => props.modelValue, (newValue) => {
  localValue.value = newValue;
});
</script>

<template>
  <div class="select-container">
    <label :for="label" class="select-label" :style="{ minWidth: minWidthLabel }">{{ label }}</label>
    <BaseSelect v-model="localValue" :options="options" />
  </div>
</template>

<style scoped>
.select-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center; /* Ensure vertical alignment */
  justify-content: center; /* Center horizontally */
  padding: 1rem;
}

.select-label {
  margin: 0; /* Remove default margin */
  text-align: left;
  padding: 0;
  flex-shrink: 0;
}
</style>

